export default "__VITE_ASSET__CVI$u55K__"